<div id="reasons-to-love">
	<h2>Reasons to love Rent-A-Store&hellip;</h2>
	<div class="row three-cols">
		<div class="col">
			<h3>Free move-in transport</h3>
			<img loading="lazy" [src]="'assets/iconTransport.svg'" alt="Free move-in transport">
			<p>It's a huge saving and one less thing to arrange. We offer the use of either a Rent-A-Store truck or trailer for your initial move in to our facilities.</p>
		</div>
		<div class="col">
			<h3>No deposit or move-in fees</h3>
			<img loading="lazy" [src]="'assets/iconDeposit.svg'" alt="No deposit or move-in fees">
			<p>You will not need to pay a security deposit and you won't be charged any additional admin fees for moving in.</p>
		</div>
		<div class="col">
			<h3>High security</h3>
			<img loading="lazy" [src]="'assets/iconSecurity.svg'" alt="High security storage">
			<p>Have assurance that your belongings are in a high-security environment. State-of-the-art systems &amp; procedures are in place at all our sites.</p>
		</div>
		<ng-container *ngIf="show_more_reasons">
			<div class="col">
				<h3>Various sizes</h3>
				<img loading="lazy" [src]="'assets/iconSizes.svg'" alt="Various storage unit sizes">
				<p>Units sizes between 1sqm and 54sqm are available to suit your storage requirements and budget.</p>
			</div>
			<div class="col">
				<h3>Facility excellence</h3>
				<img loading="lazy" [src]="'assets/iconFacilityExcellence.svg'" alt="Facility excellence">
				<p>Neat, clean and tidy. Specifically designed storage buildings, restrooms and relaxation areas are meticulously maintained for your convenience and comfort.</p>
			</div>
			<div class="col">
				<h3>Service excellence</h3>
				<img loading="lazy" [src]="'assets/iconServiceExcellence.svg'" alt="Service excellence">
				<p>Fast simple and friendly. Enjoy a hassle free experience, we employ clear headed and enthusiastic staff to make Rent-A-Store the name you will recommend in self-storage.</p>
			</div>
			<div class="col">
				<h3>Month-to-month rentals</h3>
				<img loading="lazy" [src]="'assets/iconRentals.svg'" alt="Month-to-month rentals">
				<p>No long-term lease agreements, rentals are on a month-to-month basis, with one full calendar month notice required prior to moving out.</p>
			</div>
			<div class="col">
				<h3>Special offers</h3>
				<img loading="lazy" [src]="'assets/iconPromotions.svg'" alt="Special offers and promotions">
				<p>Keep a lookout on the website for any seasonal and other unbelievable rental discounts and promotions.</p>
			</div>
			<div class="col">
				<h3>Rent online</h3>
				<img loading="lazy" [src]="'assets/iconOnline.svg'" alt="Easy online booking">
				<p>The easiest fastest way to rent self-storage, from selecting a unit size to booking your free move in transport to e-signing the lease agreement and paying, only take 15 minutes.</p>
			</div>
			<div class="col">
				<h3>Packing supplies</h3>
				<img loading="lazy" [src]="'assets/iconSupplies.svg'" alt="Packing supplies available">
				<p>Boxes and all you need to move and store are available for purchase online or instore.</p>
			</div>
			<!-- <div class="col">
				<h3>10 free boxes with every online rental</h3>
				<img loading="lazy" [src]="'assets/iconBoxPack.svg'" alt="">
				<p>With every online rental you will receive a coupon for a free box pack worth R230! Get all the supplies you will need to move and store your goods safely</p>
			</div> -->
		</ng-container>
	</div>
</div>